import { RegistrationError } from 'shared/hooks/api/demo';

interface FormikHelpers {
  setSubmitting: (isSubmitting: boolean) => void;
  setStatus: (status: unknown) => void;
  setFieldError?: (field: string, message: string) => void;
}

export const onRegistrationSuccess = ({
  setSubmitting,
  setStatus,
}: FormikHelpers): void => {
  setSubmitting(false);
  setStatus({ success: true });
};

export const onRegistrationError = (
  error: RegistrationError,
  { setSubmitting, setStatus, setFieldError }: FormikHelpers
): void => {
  if (error instanceof RegistrationError && error.status === 400) {
    const data = { ...error.fieldErrors } as Record<string, unknown>;

    if (data.additional_infos) {
      const additionalInfos = data.additional_infos as Record<string, string>;
      Object.keys(additionalInfos).forEach((key) => {
        setFieldError?.(`additional_infos.${key}`, additionalInfos[key]);
      });
      delete data.additional_infos;
    }

    Object.keys(data).forEach((key) => {
      setFieldError?.(key, data[key] as string);
    });
  } else {
    setStatus({ apiError: 'An error occured' });
  }

  setSubmitting(false);
};
